import '../App.css';
import { gql, useApolloClient } from "@apollo/client";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useRef, useState } from 'react';
import { MapContainer, Marker, TileLayer, Tooltip } from 'react-leaflet';
import { useNavigate, useParams } from 'react-router-dom';
import { getArea } from './hotspots';
import Passeio from './passeio';

const GET_DATA_PAGINATED = gql`
  query GetMicronarrativas($after: String, $first: Int = 100, $order: OrderEnum = ASC) {
    micronarrativas(first: $first, after: $after, where: { orderby: { field: DATE, order: $order } }) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          title
          micronarrativasMeta {
            hotspot
            data
            latitude
            longitude
            tags_micro {
              edges {
                node {
                  id
                  name
                }
              }
            }
            narrativa
            imagem {
              node {
                mediaItemUrl
              }
            }
            autor
          }
        }
      }
    }
  }
`;

export function useHotspotData(tag) {
  const client = useApolloClient();
  const [state, setState] = useState({
    loading: true,
    error: null,
    data: [],
  });

  useEffect(() => {
    let cancelled = false;

    async function fetchAll() {
      let after = null;
      const allEdges = [];

      try {
        do {
          const { data } = await client.query({
            query: GET_DATA_PAGINATED,
            variables: { after, first: 100, order: "ASC" },
            fetchPolicy: "network-only",
          });

          const conn = data?.micronarrativas;
          if (!conn) break;

          allEdges.push(...(conn.edges || []));
          after = conn.pageInfo?.endCursor || null;


          if (!conn.pageInfo?.hasNextPage) break;
        } while (true);

        if (cancelled) return;

        console.log(`Finished fetching all entries: ${allEdges.length} total`);

        const filtered = allEdges
        .filter(({ node }) =>
          node.micronarrativasMeta.tags_micro.edges.some(
            ({ node: tagNode }) => tagNode.name === tag
          )
        )
        .map(({ node }) => ({
          id: node.id,
          hotspot: node.micronarrativasMeta.hotspot,
          narrativa: node.micronarrativasMeta.narrativa,
          data: node.micronarrativasMeta.data,
          tags: node.micronarrativasMeta.tags_micro.edges,
          imagem: node.micronarrativasMeta.imagem.node.mediaItemUrl,
          autor: node.micronarrativasMeta.autor,
        }));


        setState({ loading: false, error: null, data: filtered });
      } catch (error) {
        if (cancelled) return;
        setState({ loading: false, error, data: [] });
      }
    }

    setState((s) => ({ ...s, loading: true }));
    fetchAll();

    return () => {
      cancelled = true;
    };
  }, [client, tag]);

  return state;
}

export default function TagPage(){
    const [index, setIndex] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const { tag } = useParams();
    const { loading, error, data: micronarrativas } = useHotspotData(tag);
    const popup = useRef(null);
    const navigate = useNavigate();
    const [selection, setSelection] = useState(0);

    const handleTagClick = (tag) => {
      window.open(`/tags/${tag}`, '_blank');
    };

  const handleAreaClick = (area) => {
    window.open(`/areas/${selection.area}`, '_blank');
  }

  useEffect(() => {
      console.log(selection);
    },[selection]);


    const handleClick = (id) => {
      setSelection(getArea(micronarrativas[id].hotspot));
      setIndex(id);
      setPopupOpen(true);
    }

    const popupClose = () => {
      setIndex(null);
      setPopupOpen(false);
    }

    return (
    <div className='tag-wrapper'>
      <Passeio></Passeio>
      <button className="back-button" onClick={() => navigate("/tags")}>
        <ArrowBackIcon/>
        <span>Tags</span>
      </button>
      <div className='tag-gallery'>
        <div className='title-page'>
          <div className='title-tag'>
            {tag}
          </div>
        </div>
        {
        micronarrativas.map((item, id) => (
          <div onClick={() => handleClick(id)} className='tag-thumb' key={id}>
            <img key={id} src={item.imagem} alt={`Thumbnail ${id}`} />
          </div>
        ))
      }
      </div>
      {popupOpen && <div ref={popup} className='popup open-popup-tag' onClick={popupClose}>
        <div className='popup-wrapper' onClick={(e) => e.stopPropagation()}>
          <div className='close-popup' onClick={popupClose}>
            <CloseIcon></CloseIcon>
          </div>
        <div className='imagem-tag'> 
          <img src={index === null ? null : micronarrativas[index].imagem } alt="Selected" />
        </div>
        <div className='narrativa-popup'>
          <div className='Corpo'>
            <div>
              <span>{index === null ? null : micronarrativas[index].narrativa}</span>
            </div>
            <div className='Sub-texto'>
              Por <span>{micronarrativas[index].autor}</span> -
              <span>
                {new Date(micronarrativas[index].data).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                })}
              </span>
        </div>
            <div className='Tags'>
              {index === null ? null : micronarrativas[index].tags.map(({ node, id }) => (
                <span
                  key={id}
                  className='Tag'
                  onClick={() => handleTagClick(node.name)}
                  style={{ cursor: 'pointer' }}
                >
                {node.name}
                </span>
              ))}
            </div>
          </div>
            <div style={{ height: '150px', width: '100%' }} >
                        <MapContainer
                          center={selection.geo}
                          zoom={15}
                          scrollWheelZoom={false}
                          dragging={false} 
                          style={{ height: '150px', width: '100%' }}
                          zoomControl={false}
                        >
                          <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                          />
                          <Marker position={selection.geo}
                          eventHandlers={{
                              click: () => {
                              handleAreaClick(selection.area);
                          },}}>
                            <Tooltip direction="top" offset={[-15, -15]} opacity={1} permanent={false}>
                              {selection.area}
                            </Tooltip>
                          </Marker>
                        </MapContainer>
                    </div>
        </div>
        </div>
        </div>
      }
    </div>
    );
}